import { render } from "./Calculation.vue?vue&type=template&id=7de33392&scoped=true&ts=true"
import script from "./Calculation.vue?vue&type=script&lang=ts"
export * from "./Calculation.vue?vue&type=script&lang=ts"

import "./Calculation.vue?vue&type=style&index=0&id=7de33392&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de33392"]])

export default __exports__